import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import { Menu, Grid, Image, Dropdown, Icon } from 'semantic-ui-react'
import './header.scss';
import logoImg from '../../../assets/img/censio_logo.png';
import userImage from '../../../assets/img/NewProfileImage.png';
import { useDispatch, useSelector } from 'react-redux';
// import { toggleSidebar } from "../../../Actions/componentActions";
// import ProfileModal from "../ProfileModal/ProfileModal";
import usdImage from '../../../assets/img/udc-logo-long.png';

import NewProfileModal from "../../NewProfileModal/index";
import { togglePopup } from "../../../Actions/componentActions";
import { getLogoutRedirectPath } from "../../routes/logoutRedirect";


export default function HeaderComponent({ visible, setVisible }) {
    const profileDetail = useSelector(state => (state.profileReducer.profileDetail));
    const userRole = profileDetail?.data?.user?.role || sessionStorage.getItem("userRole")
    const isEntrepreneurAdmin = userRole === "entrepreneur_admin"
    const isAdmin = profileDetail?.data?.user?.admin || sessionStorage.getItem("isAdmin") === "true" || isEntrepreneurAdmin ? true : false


    // const assessment_started = sessionStorage.getItem("assessment_started") === "true" ? true : false
    const dispatch = useDispatch()
    const [userName, setUserName] = useState("")
    const history = useHistory()
    const [profileImage, setProfileImage] = useState((profileDetail && profileDetail.avatar) ? profileDetail.avatar : sessionStorage.getItem("profileImage"))
    const [open, setOpen] = useState(false)

    const FirstName = sessionStorage?.getItem("userName")?.split(" ")[0] || ""

    const isToggle = useSelector((state) => state.componentReducer.isToggle)
    const { sidebarHoverReducer } = useSelector(state => state)


    const profileUpdate = useSelector(state => state.profileReducer.profileUpdate)

    useEffect(() => {
        var testName = (profileDetail && profileDetail?.data?.user?.first_name) ? `${profileDetail.data.user.first_name} ${profileDetail.data.user.last_name || ''}`.trim() : sessionStorage.getItem("userName") || "Admin"

        // var testName = (profileDetail && profileDetail.data.user.first_name) ? `${profileDetail.data.user.first_name} ${profileDetail.data.user.last_name}` : sessionStorage.getItem("userName")
        setUserName(testName)
        setProfileImage((profileDetail && profileDetail.avatar) ? profileDetail.avatar : profileDetail?.data?.user ? profileDetail?.data?.user?.user_image : sessionStorage.getItem("profileImage"))
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (profileUpdate) {
            setOpen(false)
            // dispatch(updateProfileSuccess({ profileUpdate: false, data: profileDetail }))

            // dispatch(updateProfileSuccess(profileUpdate)
        }
        // eslint-disable-next-line
    }, [profileDetail])



    const handleClickLogout = () => {
        sessionStorage.clear();
        history.replace(getLogoutRedirectPath({
            pathname: window.location.pathname,
            userRole
        }));
    }

    const CloseProfileModal = () => {
        setOpen(false)
    }

    const handleProfileClick = () => {
        dispatch(togglePopup({ open: true, type: 'Profile', crossIcon: false, className: '', popUpPosition: 'top-[5.5rem] left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-4 md:right-12' }))
    }

    return (
        <div>

            <div className={isToggle ? "header-sec header-inner-sec" : `${profileDetail?.data?.user?.udc_user && "UDC_Header"} header-sec`}>
                <div className={`${sidebarHoverReducer.isHover ? "udc-header-small" : "udc-header"}`} >
                    <Grid>
                        <Grid.Row>

                            <Grid.Column computer={3} tablet={3} mobile={3} className="vt-center">
                                <Image src={logoImg} className="logo-img" onClick={() => history.push(`${isEntrepreneurAdmin ? "/admin/assessment-users" : isAdmin ? "/admin" : '/newdashboard'}`)} style={{ cursor: "pointer" }} />

                            </Grid.Column>
                            <Grid.Column computer={10} tablet={10} mobile={10} className="vt-center menus-header">
                                {profileDetail?.data?.user?.udc_user &&
                                    <Image src={usdImage} className="univerisity-image" style={{ cursor: "pointer" }} />
                                }
                            </Grid.Column>
                            <Grid.Column computer={3} tablet={3} mobile={3}>
                                {
                                    isAdmin || isEntrepreneurAdmin ? <div className="flex justify-end">
                                        <button className="flex justify-end items-center pt-2 text-[1.25rem] font-bold text-[#0f172a] hover:text-black cursor-pointer bg-transparent border-none" onClick={handleProfileClick}>
                                            <Image
                                                src={profileDetail?.data?.user?.user_image || userImage}
                                                loading="lazy"
                                                className="my-profile-img w-[50px] h-[50px] rounded-full object-cover"
                                            />
                                            <span className="ml-3 mr-1 text-[#0f172a] font-bold text-base select-none">
                                                {userName || sessionStorage.getItem("userName") || "Admin"}
                                            </span>
                                            <Icon className="caret down !text-[#0f172a] !opacity-100" style={{ color: '#0f172a', opacity: 1, fontSize: '1.1rem' }} />
                                        </button>
                                    </div>
                                        :
                                        <Menu text className="menu-header float-right">
                                            <Dropdown text={userName} className="dropdown-header !text-[#0f172a] font-bold">
                                                <Dropdown.Menu>
                                                    {!isAdmin && !isEntrepreneurAdmin ?
                                                        <Dropdown.Item text="My Profile" onClick={() => setOpen(true)}>
                                                        </Dropdown.Item>
                                                        :
                                                        null
                                                    }
                                                    <Dropdown.Item
                                                        text="Logout"
                                                        onClick={() => handleClickLogout()}
                                                    />
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <Image src={profileImage || userImage} width="40" className="my-profile-img" />
                                        </Menu>
                                }

                                {/* {open &&
                                    <Icon name="triangle down" className="profile-popup-before-icon" />
                                } */}

                                <NewProfileModal open={open} CloseProfileModal={CloseProfileModal} />
                                {/* <ProfileModal open={open} setOpen={setOpen} setUserName={setUserName} /> */}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </div>
            </div>
        </div>
    );
}
